import {GET_GROWTH_PATH_START} from "../../types";

export const growth_path = (payload) => ({
  type: GET_GROWTH_PATH_START,
  payload,
});
